import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

console.log('BUILD_VERSION:', BUILD_VERSION);
console.log('BUILD_TIME:', BUILD_TIME);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
